import { useMsal } from "@azure/msal-react";

export const useLogout = () => {
  const { instance } = useMsal();

  const logout = () => {
    instance.logoutRedirect().catch(() => {
      /* Logout redirect errors are surfaced via MSAL's event callbacks */
    });
  };

  return logout;
};
